import styled from 'styled-components';

export const FiltersContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.12);
`;

export const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(25, 118, 210, 0.04);
  }
`;
